'use client';
import React, { useState } from 'react';
import { hasCldImage, TypeBlockImageWithPartialOverlay } from '@fm-nx/contentful-types';
import { CldImage } from 'next-cloudinary';
import AnimationImage from '../animation-image/animation-image';
import { useBreakpoint } from '../hooks/useResponsive';

type ImageWithPartialOverlayWithSlotsProps = {
    blockImageWithPartialOverlay: TypeBlockImageWithPartialOverlay<'WITHOUT_UNRESOLVABLE_LINKS'>;
    componentLeft: JSX.Element;
    componentRight: JSX.Element;
};

// TODO: No longer in use after removal from contact page. Consider deleting this. -Adam
export const ImageWithPartialOverlayWithSlots = (props: ImageWithPartialOverlayWithSlotsProps) => {
    const { blockImageWithPartialOverlay, componentRight, componentLeft } = props;
    // const updatedData = useContentfulLiveUpdates(fields);
    const { fields } = blockImageWithPartialOverlay;
    // const inspectorProps = useContentfulInspectorMode({ entryId: updatedData?.sys?.id });
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const { isTabletBelow, isDesktop } = useBreakpoint();
    const imageCloudinary = hasCldImage(fields.image?.fields) ? fields.image?.fields.cloudinaryMedia[0] : null;

    if (!fields) return null;
    const { image } = fields;
    return (
        <div className="relative">
            {imageCloudinary && (
                <div className="relative w-full h-full md:h-[620px]">
                    <AnimationImage isImageLoaded={isImageLoaded}>
                        <>
                            {isDesktop && (
                                <CldImage
                                    className="z-0 hidden object-cover md:block"
                                    src={`${imageCloudinary.public_id}`}
                                    alt={image?.fields.altText || ''}
                                    priority
                                    fill
                                    sizes="100vw"
                                    onLoad={() => setIsImageLoaded(true)}
                                />
                            )}
                            {/* mobile/tablet image - cropped to face for people page */}
                            {isTabletBelow && (
                                <div className="block image-container-responsive lg:hidden">
                                    <CldImage
                                        className="image-responsive"
                                        src={`${imageCloudinary.public_id}`}
                                        alt={image?.fields.altText || ''}
                                        priority
                                        crop="thumb"
                                        width={1600}
                                        height={1600}
                                        zoom="0.75"
                                        gravity="faces"
                                        sizes="100vw"
                                        onLoad={() => setIsImageLoaded(true)}
                                    />
                                </div>
                            )}
                        </>
                    </AnimationImage>
                </div>
            )}
            <div className="mx-auto w-full mx-auto max-w-container">
                <div className="mb-14 md:mb-20">
                    <div className="relative z-10 grid grid-cols-1 gap-0 md:-mt-36 md:grid-cols-2 md:gap-8">
                        <div className="bg-white pt-14">
                            <div className="grid grid-cols-7">
                                <div className="col-span-7 col-start-1 mx-6 md:mx-0 md:col-start-2 md:col-span-5">
                                    {componentLeft}
                                </div>
                            </div>
                        </div>
                        <div className="mx-6 mt-0 md:mx-0 md:mt-96 lg:mt-48">
                            <div className="grid grid-cols-7">
                                <div className="col-span-6 mt-6">{componentRight}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageWithPartialOverlayWithSlots;
